var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-content',[_c('page-title',[_vm._v("Anmelden")]),_c('main',{attrs:{"id":"login"}},[_c('div',{staticClass:"container"},[_c('login-form')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }